import { render } from "./ErrorHandler.vue?vue&type=template&id=1d55d734&scoped=true"
import script from "./ErrorHandler.vue?vue&type=script&lang=js"
export * from "./ErrorHandler.vue?vue&type=script&lang=js"

import "./ErrorHandler.vue?vue&type=style&index=0&id=1d55d734&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Setrin\\dev\\NTS\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d55d734"]])

export default __exports__